import { TContextSocket } from './ChatSocketProvider'

export const emptyContextState: TContextSocket = {
  localState: {
    socket: undefined
  }
}
